import styled from 'styled-components';

const theme = {
  warning: {
    background: '#F5C0BA',
    color: '#9B2012',
    border: '#9B2012'
  }
};

const getColor = (variant, prop) => {
  return theme[variant][prop];
};

export const StyledAlert = styled.div(
  ({ size, type }) => `
  display: flex;
  flex-direction: column;
  height: auto;
  padding: ${size === 'medium' ? '12px' : '8px'};
  border-radius: 5px;
  background: ${getColor(type, 'background')};
  color: ${getColor(type, 'color')};
  font-size: ${size === 'medium' ? '16px' : '14px'};
  line-height: ${size === 'medium' ? '24px' : '16px'};
  border: 2px solid ${getColor(type, 'border')};
  box-sizing: border-box;
  border-radius: 4px;
  svg {
    font-size: 16px;
    margin-right: 8px;
  }
  .header {
    display: flex;
    align-items: center;
    padding-bottom: ${size === 'medium' ? '8px' : '0px'};
  }
  .title {
    font-weight: 600;
    font-style: normal;
    font-size: ${size === 'medium' ? '16px' : '14px'};
    line-height: ${size === 'medium' ? '24px' : '16px'};
    min-width: 0;
    overflow-wrap: break-word;
  }
  .content {
    font-weight: 400;
    font-style: normal;
    font-size: ${size === 'medium' ? '16px' : '14px'};
    line-height: ${size === 'medium' ? '24px' : '16px'};
  }
`
);

export const StyledButton = styled.button`
  background: #9b2012;
  border-radius: 2px;
  margin: 10px 0px;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 16px;
  border: none;
  color: #fff;
`;
